package com.merkost.handpass.admin.container

import com.merkost.handpass.admin.api.AdminRepositoryApi
import com.merkost.handpass.admin.contract.StatsAction
import com.merkost.handpass.admin.contract.StatsIntent
import com.merkost.handpass.admin.contract.StatsState
import com.merkost.handpass.admin.platform.WindowFocusTrigger
import com.merkost.handpass.admin.util.toAdminMessage
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import pro.respawn.flowmvi.api.Container
import pro.respawn.flowmvi.dsl.lazyStore
import pro.respawn.flowmvi.plugins.recover
import pro.respawn.flowmvi.plugins.reduce

class StatsContainer(
    private val repo: AdminRepositoryApi,
    private val focusTrigger: WindowFocusTrigger,
) : Container<StatsState, StatsIntent, StatsAction> {

    private val scope = MainScope()

    override val store by lazyStore(StatsState.Loading, scope) {
        configure { name = "StatsStore" }
        recover { e ->
            updateState { StatsState.Error(e.toAdminMessage()) }
            null
        }
        reduce { intent ->
            when (intent) {
                is StatsIntent.ReactToFocusTick, StatsIntent.Refresh -> {
                    val stats = repo.getStats()
                    if (stats == null) {
                        updateState { StatsState.Error("Could not reach the API") }
                    } else {
                        updateState { StatsState.Content(stats) }
                    }
                }
                StatsIntent.NavigateToQueue -> action(StatsAction.Navigate("/reports"))
            }
        }
    }

    init {
        scope.launch {
            focusTrigger.ticks.collect { tick -> store.intent(StatsIntent.ReactToFocusTick(tick)) }
        }
    }
}
